import React from "react";
import { Icon, Menu, Layout, Button } from "antd";
import "antd/dist/antd.css";
import "./subscriptions.css";

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;

export default class Subscriptions extends React.Component {
  state = {};

  render() {
    const { inputValue, deleteItem } = this.props;
    const favorites = this.props.data.concat().map(function(item) {
      return (
        <Menu.Item style={{ margin: 0 }} key={item.id}>
          <Button
            className="title-block-button"
            border="none"
            icon="close"
            onClick={() => {
              deleteItem(item.id);
            }}
          />
          <span
            onClick={() => {
              inputValue(item.doi);
            }}
          >
            {item.title}
          </span>
        </Menu.Item>
      );
    });
    return (
      <Sider
        style={{
          height: "100vh",
          left: 0,
        }}
        className="slider"
        collapsible
        theme="light"
        collapsedWidth="0"
        breakpoint="md"
        width={220}
      >
        <Menu
          defaultOpenKeys={["favorites"]}
          defaultSelectedKeys={["1"]}
          mode="inline"
        >
          <SubMenu
            key="favorites"
            title={
              <span>
                <Icon type="star" theme="filled" style={{ color: "#ffdd03" }} />
                <span>Избранное</span>
              </span>
            }
          >
            {favorites}
          </SubMenu>
        </Menu>
      </Sider>
    );
  }
}
